import React from "react";

interface ClickProps {
  children: React.ReactNode;
}

export default function ClickEventCapturer({ children }: ClickProps) {
  return <div onClick={e => e.stopPropagation()}>{children}</div>;
}
